// Figma: 6086:28468 — see stories/blocks/trusted-customers-grid-expand-button.stories.tsx
"use client";

import { AnimatePresence, motion } from "framer-motion";
import { Minus, Plus } from "iconoir-react";

import { cn } from "@/lib/utils";

interface TrustedCustomersGridExpandButtonProps {
  expanded: boolean;
  onClick: () => void;
  onPreload?: () => void;
}

function expandButtonIdleClasses() {
  return cn("bg-grey-50", "hover:bg-grey-100 active:scale-[0.97]");
}

export function TrustedCustomersGridExpandButton({
  expanded,
  onClick,
  onPreload,
}: TrustedCustomersGridExpandButtonProps) {
  return (
    <button
      type="button"
      aria-expanded={expanded}
      aria-label={expanded ? "Show less" : "Show more"}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
      onPointerEnter={onPreload}
      onFocus={onPreload}
      className={cn(
        "border-grey-100 absolute right-2.5 bottom-2.5 z-10 flex size-7 items-center justify-center rounded-full border transition-colors duration-200 ease-out motion-reduce:transition-none",
        expanded ? "bg-grey-0 hover:bg-grey-50" : expandButtonIdleClasses()
      )}
    >
      <span className="relative size-3">
        <AnimatePresence mode="wait" initial={false}>
          {expanded ? (
            <motion.span
              key="minus"
              initial={{ opacity: 0, rotate: -90, scale: 0.8 }}
              animate={{ opacity: 1, rotate: 0, scale: 1 }}
              exit={{ opacity: 0, rotate: 90, scale: 0.8 }}
              transition={{ duration: 0.2, ease: [0.22, 1, 0.36, 1] }}
              className="absolute inset-0 flex items-center justify-center"
            >
              <Minus className="text-grey-950 size-3" strokeWidth={2} />
            </motion.span>
          ) : (
            <motion.span
              key="plus"
              initial={{ opacity: 0, rotate: 90, scale: 0.8 }}
              animate={{ opacity: 1, rotate: 0, scale: 1 }}
              exit={{ opacity: 0, rotate: -90, scale: 0.8 }}
              transition={{ duration: 0.2, ease: [0.22, 1, 0.36, 1] }}
              className="absolute inset-0 flex items-center justify-center"
            >
              <Plus className="text-grey-950 size-3" strokeWidth={2} />
            </motion.span>
          )}
        </AnimatePresence>
      </span>
    </button>
  );
}
